import { render, staticRenderFns } from "./mytipofday.vue?vue&type=template&id=fe920914&scoped=true&"
import script from "./mytipofday.vue?vue&type=script&lang=js&"
export * from "./mytipofday.vue?vue&type=script&lang=js&"
import style0 from "./mytipofday.vue?vue&type=style&index=0&id=fe920914&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fe920914",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/tgs-automation/tgs-automation/mojaweb/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('fe920914')) {
      api.createRecord('fe920914', component.options)
    } else {
      api.reload('fe920914', component.options)
    }
    module.hot.accept("./mytipofday.vue?vue&type=template&id=fe920914&scoped=true&", function () {
      api.rerender('fe920914', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/tod/mytipofday.vue"
export default component.exports